<template>
  <el-dialog
    :visible.sync="isShow"
    :title="title"
    :closeOnClickModal="closeOnClickModal"
    :width="width"
    v-bind="$attrs"
    :append-to-body="true"
    custom-class="self-dialog"
    @close="handleClose"
  >
    <slot />
    <div slot="title" v-if="customerTitle">
      <slot name="title" />
    </div>
    <div slot="footer" v-if="hasFooter">
      <slot name="footer" />
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogWrap',
  model: {
    prop: 'dialogShow',
    event: 'change',
  },
  props: {
    width: {
      type: String,
      default: 'auto',
    },
    title: {
      type: String,
      default: '标题',
    },
    dialogShow: {
      type: Boolean,
      default: false,
    },
    closeOnClickModal: {
      type: Boolean,
      default: true,
    },
    hasFooter: {
      type: Boolean,
      default: true,
    },
    customerTitle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShow: false,
    }
  },
  methods: {
    handleClose() {
      this.$emit('onClose')
    },
  },
  watch: {
    dialogShow(val) {
      const _this = this
      _this.isShow = val
    },
    isShow(val) {
      const _this = this
      _this.$emit('change', val)
    },
  },
  mounted() {
    const _this = this
    _this.isShow = _this.dialogShow
  },
}
</script>

<style>
.self-dialog {
  /* min-width:400px; */
}
</style>
